import { render, staticRenderFns } from "./MiniWizardStickySubmit.vue?vue&type=template&id=26f9b264"
import script from "./MiniWizardStickySubmit.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickySubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports